import { WidgetStyle } from '../addi-product-widget/addi-product-widget.d';

export const setBannerCustomStyles = (WidgetStyle: WidgetStyle): string => {
  const styles = `
        .addi-banner-custom {
            font-family: ${WidgetStyle.fontFamily};
            border-color: ${WidgetStyle.borderColor};
            border-radius: ${WidgetStyle.borderRadius};
        }
        
        .addi-banner-wrapper {
            margin: ${WidgetStyle.margin};
        }

        .addi-banner--with-discount {
            border-radius: 0 ${WidgetStyle.borderRadius} ${WidgetStyle.borderRadius} ${WidgetStyle.borderRadius};
        }

        .addi-banner-custom-bagde {
            background-color: ${WidgetStyle.badgeBackgroundColor};
        }

        .addi-banner-custom-info {
            font-size: ${WidgetStyle.fontSize};
            color: ${WidgetStyle.fontColor};
            background-color: ${WidgetStyle.infoBackgroundColor};
        }

        .addi-banner-custom-discount {
            font-size: ${WidgetStyle.fontSize};
        }
    `;

  return styles;
};
